<div class="flex justify-center">
  <section>
    <h2 class="text-center">{{ title }}</h2>
    <button mat-raised-button color="primary" (click)="click()">
      <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon
        >{{ actionTitle }}
      </button>
      @if (imgSrc) {
        <div class="flex justify-center">
          <img class="payment-empty-state" [src]="imgSrc" />
        </div>
      }
    </section>
  </div>
